module.exports = __webpack_public_path__ + "img/zhsxpt.695048da.png";